export { default } from './FileInput';



// WEBPACK FOOTER //
// ./src/design-system/atoms/FileInput/index.jsx